/*
 * Mobile: separate "Sort by" control next to the Filter button.
 * The whole button is tappable: a transparent full-size <select> overlays
 * the visible label/value/caret. Options are cloned from #SortBy so it stays
 * in sync with the collection's sort options.
 */
(function () {
  'use strict';

  function bind(select) {
    if (select.__pbBound) return;
    select.__pbBound = true;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.hash = '';
      window.location.href = url.toString();
    });
  }

  function build() {
    // snippets/facets.liquid renders the control and bar server-side (so the
    // sticky bar is in place at first paint); just wire it up. Building it
    // here is only a fallback for markup that doesn't include it.
    var rendered = document.querySelector('.facets-container .pb-mobile-sort__select');
    if (rendered) { bind(rendered); return; }

    if (window.innerWidth >= 990) return;                 // mobile only
    var container = document.querySelector('.facets-container');
    var filterWrap = document.querySelector('.mobile-facets__wrapper');
    var source = document.getElementById('SortBy');
    if (!container || !filterWrap || !source) return;

    var wrap = document.createElement('div');
    wrap.className = 'pb-mobile-sort';

    var label = document.createElement('span');
    label.className = 'pb-mobile-sort__label';
    label.textContent = 'Sort by';
    wrap.appendChild(label);

    var value = document.createElement('span');
    value.className = 'pb-mobile-sort__value';
    wrap.appendChild(value);

    var select = document.createElement('select');
    select.className = 'pb-mobile-sort__select';
    select.setAttribute('aria-label', 'Sort by');
    for (var i = 0; i < source.options.length; i++) {
      var opt = document.createElement('option');
      opt.value = source.options[i].value;
      opt.textContent = source.options[i].textContent.trim();
      if (source.options[i].selected) {
        opt.selected = true;
        value.textContent = opt.textContent;
      }
      select.appendChild(opt);
    }
    if (!value.textContent && select.options[select.selectedIndex]) {
      value.textContent = select.options[select.selectedIndex].textContent;
    }
    bind(select);
    wrap.appendChild(select);

    filterWrap.insertAdjacentElement('afterend', wrap);

    // The white bar behind FILTER and SORT BY is a real element, not a
    // pseudo-element: iOS 26 Safari only extends the colour of a real
    // full-width fixed element down under its glass toolbar.
    var bar = document.createElement('div');
    bar.className = 'pb-mobile-bar';
    bar.setAttribute('aria-hidden', 'true');
    container.appendChild(bar);

    container.classList.add('pb-has-mobile-sort');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  document.addEventListener('shopify:section:load', build);
})();
